<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Detail Pesanan</h4>
    </div>
    <div class="card-body px-4 pb-4">
      <div v-if="renderComponent" id="smartwizard">
        <ul class="nav">
          <template v-for="(pc, index) in processingColumn">
            <li :key="pc.index + 1">
              <a class="nav-link" :href="'#step-' + (index + 1)">
                <i
                  id="iconBar"
                  :data-active="pc.isActive"
                  style="font-size: 14px"
                  :class="
                    pc.title === 'Konfirmasi'
                      ? 'fas fa-folder-open'
                      : pc.title === 'Diproses'
                      ? 'fas fa-hourglass-half'
                      : pc.title === 'Diterima'
                      ? 'fa fa-store'
                      : pc.title === 'Dibayar'
                      ? 'far fa-credit-card'
                      : pc.title === 'Dikomplain'
                      ? 'fas fa-comment-slash'
                      : pc.title === 'Dibekukan'
                      ? 'fas fa-ban'
                      : pc.title === 'Dibatalkan'
                      ? 'fas fa-times-circle'
                      : 'fas fa-shipping-fast'
                  "
                ></i>
                <br />
                <span style="font-size: 12px">{{ pc.titleMenu }} </span>
              </a>
            </li>
          </template>
        </ul>

        <div class="tab-content" style="height: auto">
          <template v-for="(pc, index) in processingColumn">
            <div
              v-if="pc.isActive"
              :data-selected="pc.index"
              :id="pc.isActive ? 'step-' + (index + 1) : 'step-1'"
              class="tab-pane"
              :key="pc.index + 1"
              role="tabpanel"
            >
              <template v-if="pc.isActive">
                <div class="card" style="box-shadow: none; height: auto">
                  <div class="card-body">
                    <!-- confirm -->
                    <blockquote
                      v-if="pc.value == 'confirm'"
                      class="p-4 mb-0 text-center"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                      </div>
                      <img
                        src="@/assets/upload/office.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                      />
                      <div
                        v-if="processingData.isHasRequestChange"
                        class="card card-body"
                      >
                        <p class="badge badge-soft-danger font-weight-bold">
                          Customer ingin request perubahan pada pesanan ini
                        </p>
                        <br />
                        <span style="font-size: 12px"
                          >Tekan tombol detail request untuk meilhat permintaan
                          perubahan invoice</span
                        >
                        <br />
                        <button
                          class="btn btn-dark"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseExample"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          Detail Request
                        </button>

                        <div class="collapse" id="collapseExample">
                          <div class="">
                            <content-placeholders
                              :rounded="true"
                              :animated="false"
                            >
                              <div class="p-4">
                                <div class="card-body">
                                  <div class="invoice-title">
                                    <h4
                                      class="float-end"
                                      style="font-size: 16px"
                                    >
                                      <strong> Perubahan Quantity </strong>
                                      <i
                                        class="
                                          fas
                                          fa-receipt
                                          text-primary
                                          pull-right
                                        "
                                        style="font-size: 20px"
                                      ></i>
                                    </h4>
                                  </div>

                                  <div class="table-responsive">
                                    <table
                                      class="table text-center"
                                      width="100%"
                                    >
                                      <tbody>
                                        <tr
                                          v-for="(rq,
                                          index) in itemsRequestChange"
                                          :key="index"
                                        >
                                          <td>{{ index + 1 }}</td>
                                          <td class="text-center">
                                            <div class="zoom-gallery">
                                              <a
                                                :href="rq.image"
                                                :title="rq.name"
                                              >
                                                <img
                                                  :src="rq.image"
                                                  width="100px"
                                                  height="auto"
                                                />
                                              </a>
                                            </div>
                                          </td>
                                          <td class="text-center">
                                            {{ rq.name }}
                                          </td>
                                          <td class="text-center removeContent">
                                            {{ rq.priceCurrencyFormat }}
                                          </td>
                                          <td class="text-center">
                                            {{ rq.qty }}
                                          </td>
                                          <td class="text-center">
                                            {{ rq.totalPriceCurrencyFormat }}
                                          </td>
                                          <td>
                                            <span
                                              class="
                                                badge badge-soft-warning
                                                text-black-50
                                              "
                                              v-if="rq.requestChange.isDisabled"
                                              >Permintaan hapus produk</span
                                            >
                                            <span
                                              class="
                                                badge badge-soft-warning
                                                text-black-50
                                              "
                                              v-else
                                              >Permintaan ubah jumlah <br />
                                              produk menjadi
                                              {{ rq.requestChange.qty }}</span
                                            >
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <button
                                        class="btn btn-primary"
                                        style="font-size: 12px"
                                        @click="acceptRequestChange"
                                      >
                                        <i class="fa fa-check-circle"></i>Terima
                                        Perubahan
                                      </button>
                                    </div>
                                    <div class="col-md-6">
                                      <button
                                        class="btn btn-danger"
                                        style="font-size: 12px"
                                        @click="rejectRequestChange"
                                      >
                                        <i class="fa fa-times-circle"></i>Tolak
                                        Perubahan
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </content-placeholders>
                          </div>
                        </div>
                      </div>
                      <p class="text-muted">
                        Yang dapat anda lakukan berikutnya:
                      </p>
                      <button
                        :disabled="
                          processingData.isHasRequestChange ||
                            isProductUncategorized
                        "
                        class="btn btn-sm btn-primary"
                        @click="confirmOrder"
                        id="confirmOrder"
                      >
                        Proses Pesanan
                      </button>
                      <button
                        class="btn btn-sm btn-danger"
                        @click="openModalRefuseOrder"
                        id="refuseOrder"
                      >
                        Tolak Pesanan
                      </button>
                      <!-- <button class,
                  testSwal:{type:Function}="btn btn-warning" @click="testPropFn">testprops</button> -->
                      <!-- <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>  -->
                    </blockquote>
                    <!-- end confirm -->
                    <!-- proccess -->
                    <blockquote
                      v-if="pc.value === 'process'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                      </div>

                      <template v-if="processingData.isShippingMitra">
                        <div class="row">
                          <div class="col-md-5 float-left">
                            <img
                              src="@/assets/upload/diproses2.png"
                              height="225px"
                              style="opacity: 0.9"
                              alt=""
                              class="mb-2"
                            />
                          </div>
                          <div
                            class="
                              col-md-7
                              float-right
                              d-flex
                              justify-content-center
                            "
                          >
                            <ul
                              class="list-group list-group-flush mb-4"
                              style="font-size: 12px"
                            >
                              <li class="list-group-item">
                                1. Tekan Proses jika ingin mengirim dan menerima
                                pesanan ini
                              </li>
                              <li class="list-group-item">
                                2. Label Pengiriman akan terbuat setelah pesanan
                                sudah dikirm
                              </li>
                            </ul>

                            <!-- <p style="font-size: 12px">
                              *Pengiriman dengan "kurir penyedia" tidak perlu
                              mengisi form resi. Silakan langsung klik pada tombol
                              Kirim
                            </p> -->
                          </div>
                        </div>
                      </template>

                      <template v-else>
                        <div class="row">
                          <div class="col-md-5 float-left">
                            <img
                              src="@/assets/upload/diproses2.png"
                              height="225px"
                              style="opacity: 0.9"
                              alt=""
                              class="mb-2"
                            />
                          </div>
                          <div
                            class="
                              col-md-7
                              float-right
                              d-flex
                              justify-content-center
                            "
                          >
                            <ul
                              class="
                                list-group
                                align-self-center
                                list-group-flush
                                mb-4
                              "
                              style="font-size: 12px"
                            >
                              <li class="list-group-item">
                                1. Cetak Label Pengiriman
                              </li>
                              <!-- <li class="list-group-item">
                                2. Masukkan lembar Invoice dan BAST kedalam paket
                              </li> -->
                              <li class="list-group-item">
                                2. Tempel label pengiriman diluar paket
                              </li>
                            </ul>

                            <!-- <p style="font-size: 12px">
                              *Pengiriman dengan "kurir penyedia" tidak perlu
                              mengisi form resi. Silakan langsung klik pada tombol
                              Kirim
                            </p> -->
                          </div>
                        </div>
                      </template>

                      <div
                        v-if="processingData.isHasRequestChange"
                        class="card card-body"
                      >
                        <p class="badge badge-soft-danger font-weight-bold">
                          Customer ingin request perubahan pada pesanan ini
                        </p>
                        <br />
                        <span style="font-size: 12px"
                          >Tekan tombol detail request untuk meilhat permintaan
                          perubahan invoice</span
                        >
                        <br />
                        <button
                          class="btn btn-dark"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseExample"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          Detail Request
                        </button>

                        <div class="collapse" id="collapseExample">
                          <div class="">
                            <content-placeholders
                              :rounded="true"
                              :animated="false"
                            >
                              <div class="p-4">
                                <div class="card-body">
                                  <div class="invoice-title">
                                    <h4
                                      class="float-end"
                                      style="font-size: 16px"
                                    >
                                      <strong> Perubahan Quantity </strong>
                                      <i
                                        class="
                                          fas
                                          fa-receipt
                                          text-primary
                                          pull-right
                                        "
                                        style="font-size: 20px"
                                      ></i>
                                    </h4>
                                  </div>

                                  <div class="table-responsive">
                                    <table
                                      class="table text-center"
                                      width="100%"
                                    >
                                      <tbody>
                                        <tr
                                          v-for="(rq,
                                          index) in itemsRequestChange"
                                          :key="index"
                                        >
                                          <td>{{ index + 1 }}</td>
                                          <td class="text-center">
                                            <div class="zoom-gallery">
                                              <a
                                                :href="rq.image"
                                                :title="rq.name"
                                              >
                                                <img
                                                  :src="rq.image"
                                                  width="100px"
                                                  height="auto"
                                                />
                                              </a>
                                            </div>
                                          </td>
                                          <td class="text-center">
                                            {{ rq.name }}
                                          </td>
                                          <td class="text-center removeContent">
                                            {{ rq.priceCurrencyFormat }}
                                          </td>
                                          <td class="text-center">
                                            {{ rq.qty }}
                                          </td>
                                          <td class="text-center">
                                            {{ rq.totalPriceCurrencyFormat }}
                                          </td>
                                          <td>
                                            <span
                                              class="
                                                badge badge-soft-warning
                                                text-black-50
                                              "
                                              v-if="rq.requestChange.isDisabled"
                                              >Permintaan hapus produk</span
                                            >
                                            <span
                                              class="
                                                badge badge-soft-warning
                                                text-black-50
                                              "
                                              v-else
                                              >Permintaan ubah jumlah <br />
                                              produk menjadi
                                              {{ rq.requestChange.qty }}</span
                                            >
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <button
                                        class="btn btn-primary"
                                        style="font-size: 12px"
                                        @click="acceptRequestChange"
                                      >
                                        <i class="fa fa-check-circle"></i>Terima
                                        Perubahan
                                      </button>
                                    </div>
                                    <div class="col-md-6">
                                      <button
                                        class="btn btn-danger"
                                        style="font-size: 12px"
                                        @click="rejectRequestChange"
                                      >
                                        <i class="fa fa-times-circle"></i>Tolak
                                        Perubahan
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </content-placeholders>
                          </div>
                        </div>
                      </div>

                      <div
                        class="card card-body"
                        v-if="processingData.isHasApplyCancel"
                      >
                        <p class="badge badge-soft-warning font-weight-bold">
                          Customer ingin membatalkan pesanan ini!
                        </p>
                        <br />
                        <button
                          class="btn btn-primary btn-sm mb-3"
                          @click="acceptApplyCancel"
                        >
                          Terima Pembatalan
                        </button>
                        <button
                          class="btn btn-danger btn-sm mb-3"
                          @click="rejectApplyCancel"
                        >
                          Tolak Pembatalan
                        </button>
                      </div>

                      <!-- 
                  <p class="text-danger" style="font-size: 12px">
                    Peringatan terakhir, tekan tombol dibawah jika sekolah
                    mengonfirmasi batal atau anda tidak dapat memenuhi pesanan
                    ini
                  </p> -->

                      <p style="font-size: 12px">
                        Ekspedisi: {{ shipping.name }}
                      </p>
                      <!-- <h5 class="font-weight-bold">
                    Klik tombol 'kirim' jika pesanan akan dikirim
                  </h5> -->
                      <div class="form-group">
                        <div class="d-flex justify-content-center">
                          <template
                            v-if="
                              processingData.isFaktur ||
                                processingData.isHasRequestChange
                            "
                          >
                            <!-- <input
                          class="form-control col-5"
                          type="text"
                          name="awb"
                          id="resi"
                          placeholder="Waybill"
                        /> -->

                            <button
                              :disabled="
                                processingData.isHasRequestChange ||
                                  processingData.isHasApplyCancel ||
                                  isProductUncategorized
                              "
                              @click="sendOrder"
                              type="button"
                              style="margin: 0px"
                              :class="
                                processingData.isHasRequestChange ||
                                processingData.isHasApplyCancel
                                  ? 'btn-secondary btn btn-sm mr-2'
                                  : 'btn-primary btn btn-sm mr-2'
                              "
                            >
                              <i
                                class="fa fa-shipping-fast"
                                aria-hidden="true"
                              ></i>
                              Kirim
                            </button>

                            <button
                              @click="openModalRefuseOrder"
                              type="button"
                              style="margin: 0px"
                              class="btn-danger btn btn-sm"
                            >
                              <i
                                class="fa fa-shipping-fast"
                                aria-hidden="true"
                              ></i>
                              Tolak Pesanan
                            </button>

                            <!-- <button
                    class="btn btn-secondary btn-sm mb-3"
                    @click="refuseOrder"
                  >
                    Tolak Pesanan
                  </button> -->
                          </template>
                          <template v-else>
                            <p>
                              <b>Cetak BAST dan Invoice</b> terlebih dahulu
                              untuk mengirim.
                            </p>
                          </template>
                        </div>
                      </div>
                      <!-- <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>  -->
                    </blockquote>
                    <!-- end process -->
                    <!-- diterima -->
                    <blockquote
                      v-if="pc.value == 'sent'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                        <p v-if="processingData.isPickup">
                          Pesanan sedang dikirim
                        </p>
                        <!-- <p v-if="processingData.isShippingMitra"></p>
                    barang akan di pickup oleh mitra pengiriman -->
                      </div>
                      <img
                        src="@/assets/upload/diterima.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                      />
                      <br />
                      <p class="badge badge-soft-primary">
                        Menunggu sekolah mengkonfirmasi bahwa pesanan sudah
                        sampai
                      </p>
                      <!-- <button class="btn btn-danger">Komplain ke sekolah</button>
                  <button class="btn btn-sm btn-info">Print eBast</button> -->
                    </blockquote>
                    <!-- end diterima -->
                    <!-- dikomplain -->
                    <blockquote
                      v-if="pc.value == 'complaint'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <p v-if="processingData.isPickup">
                          Pesanan sedang dikirim
                        </p>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                        <!-- <p v-if="processingData.isShippingMitra"></p>
                    barang akan di pickup oleh mitra pengiriman -->
                      </div>
                      <img
                        src="@/assets/upload/complaint2.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                      />
                      <br />
                      <p class="badge badge-soft-danger">
                        Terdapat Komplain yang harus diselesaikan
                      </p>
                      <!-- <button class="btn btn-danger">Komplain ke sekolah</button>
                  <button class="btn btn-sm btn-info">Print eBast</button> -->
                    </blockquote>
                    <!-- end dikomplain -->
                    <!-- dibekukan -->
                    <blockquote
                      v-if="pc.value == 'frozen'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                        <!-- <p v-if="processingData.isShippingMitra"></p>
                    barang akan di pickup oleh mitra pengiriman -->
                      </div>
                      <img
                        src="@/assets/upload/complaint2.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                      />
                      <br />
                      <p class="badge badge-dark">
                        Pesanan ini telah dibekukan
                      </p>
                      <!-- <button class="btn btn-danger">Komplain ke sekolah</button>
                  <button class="btn btn-sm btn-info">Print eBast</button> -->
                    </blockquote>
                    <!-- end dibekukan -->
                    <!-- accept -->
                    <blockquote
                      v-if="pc.value == 'accept'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <p v-if="processingData.isPickup">
                          Barang sudah di ambil oleh sekolah
                        </p>
                        <p v-if="processingData.isShippingMitra">
                          Barang akan di pickup oleh mitra pengiriman
                        </p>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                      </div>
                      <img
                        src="@/assets/upload/diterima.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                      />
                      <p class="text-muted">
                        Yang dapat anda lakukan berikutnya:
                      </p>

                      <button
                        type="button"
                        class="btn btn-primary"
                        data-toggle="modal"
                        data-target="#complaintModal"
                        id="complainButton"
                      >
                        <!-- Yang terender -->
                        Komplain ke Sekolah
                      </button>
                      <!-- <button class="btn btn-sm btn-info">Print eBast</button> -->
                    </blockquote>
                    <!-- end accept -->
                    <!-- paid -->
                    <blockquote
                      v-if="pc.value == 'paid'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">
                          {{ processingData.isDone ? "Selesai" : pc.title }}
                        </h5>
                        <p>{{ pc.subTitle }}</p>
                        <div
                          class="alert alert-warning"
                          v-if="isProductUncategorized"
                        >
                          <i
                            class="fa fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                          Anda perlu update kategori produk
                        </div>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                      </div>
                      <img
                        v-if="processingData.isDone"
                        src="@/assets/upload/isdone.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                        class="mb-4"
                      />
                      <img
                        v-else
                        src="@/assets/upload/complain.png"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                        class="mb-4"
                      />
                      <br />
                      <span
                        v-if="processingData.isDone"
                        class="badge badge-soft-success p-2 mb-2"
                      >
                        Sudah Selesai
                      </span>
                      <span v-else class="badge badge-soft-info p-1 mb-2">
                        Menunggu Konfirmasi dari SIPLah Eureka
                      </span>
                      <br />

                      <!-- <p class="text-muted small">
                        Yang dapat anda lakukan berikutnya:
                      </p> -->
                      <p
                        v-if="orderStatusId === '20'"
                        class="text-muted"
                        style="font-size: 12px"
                      >
                        Dana dari pembeli sudah ditransfer ke
                        <b>{{ user.name }}</b> oleh mitra (Eurekabookhouse)
                      </p>
                      <button
                        v-if="orderStatusId === '17'"
                        type="button"
                        class="btn btn-primary"
                        data-toggle="modal"
                        data-target="#complaintModal"
                        id="complainButton"
                      >
                        Komplain ke Sekolah
                      </button>
                      <p
                        v-if="orderStatusId === '17'"
                        class="text-muted m-0"
                        style="font-size: 12px"
                      >
                        Jika terdapat masalah dalam pembayaran, silahkan
                        <strong> komplain</strong> ke pihak sekolah
                      </p>
                      <!-- <button
                    v-if="orderStatusId === '18'"
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#complaintModal"
                    id="complainButtonToMitra"
                  >
                    Komplain ke Mitra
                  </button> -->
                    </blockquote>
                    <!-- end paid -->
                    <!-- refuse -->
                    <blockquote
                      v-if="pc.value == 'refuse'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p v-html="pc.subTitle"></p>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                      </div>
                      <img
                        src="@/assets/upload/cancel.jpg"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                        class="mb-2"
                      />
                      <p class="text-muted">
                        Yang dapat anda lakukan berikutnya:
                      </p>
                      <span class="font-italic badge badge-secondary p-2">
                        Tidak tersedia pilihan aksi saat ini
                      </span>
                    </blockquote>
                    <!-- end refuse -->
                    <!-- close -->
                    <blockquote
                      v-if="pc.value == 'close'"
                      class="p-4 text-center mb-0"
                    >
                      <div class="text-left">
                        <h5 class="font-weight-bold">{{ pc.title }}</h5>
                        <p v-html="pc.subTitle"></p>
                        <template v-for="(cd, index) in complaintData">
                          <p :key="index">
                            <span class="badge badge-soft-warning">{{
                              cd.escalation
                            }}</span>
                          </p>
                        </template>
                      </div>
                      <img
                        src="@/assets/upload/cancel.jpg"
                        height="225px"
                        style="opacity: 0.8"
                        alt=""
                        class="mb-2"
                      />
                      <p class="text-muted">
                        Yang dapat anda lakukan berikutnya:
                      </p>
                      <span class="font-italic badge badge-secondary p-2">
                        Tidak tersedia pilihan aksi saat ini
                      </span>
                    </blockquote>
                    <!-- end close -->
                  </div>
                </div>
              </template>
              <template v-if="!pc.isActive">
                <p>ini sandbox</p>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

//
<script>
import { mapGetters } from "vuex";
// import DetailPesanan  from './DetailPesanan'
// import axios from "axios";
// import $ from "jquery";

export default {
  components: {},

  props: {
    orderSummary: {},
    renderComponent: Boolean,
    processingColumn: {},
    processingData: {},
    shipping: {},
    confirmOrder: { type: Function },
    refuseOrder: { type: Function },
    sendOrder: { type: Function },
    arrivedOrder: { type: Function },
    orderSummaryCol: {},
    itemsRequestChange: {},
    acceptRequestChange: { type: Function },
    rejectRequestChange: { type: Function },
    acceptApplyCancel: { type: Function },
    rejectApplyCancel: { type: Function },
    complaintData: {},
    orderStatusId: String,
    Skeleton: Boolean,
    isProductUncategorized: Boolean,
    openModalRefuseOrder: { type: Function },
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  watch: {
    processingColumn() {
      console.log(this.processingColumn);
    },
  },
  mounted: function() {
    // if (condition) {

    // }
    setTimeout(() => {
      // console.log($('#iconBar'))
    }, 1000);
  },
};
</script>

<style scoped>
.sw {
  position: relative;
}

.sw *,
.sw ::after,
.sw ::before {
  box-sizing: border-box;
}

.sw > .tab-content {
  position: relative;
  overflow: hidden;
}

.sw .toolbar {
  padding: 0.8rem;
}

.sw .toolbar > .btn {
  display: inline-block;
  text-decoration: none;
  text-align: center;
  text-transform: none;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
  cursor: pointer;
}

.sw .toolbar > .btn.disabled,
.sw .toolbar > .btn:disabled {
  opacity: 0.65;
}

.sw > .nav {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
}

@media screen and (max-width: 640px) {
  .sw > .nav {
    flex-direction: column !important;
    flex: 1 auto;
  }
}

.sw > .nav .nav-link {
  display: block;
  padding: 0.5rem 1rem;
  text-decoration: none;
}

.sw > .nav .nav-link:active,
.sw > .nav .nav-link:focus,
.sw > .nav .nav-link:hover {
  text-decoration: none;
}

.sw > .nav .nav-link::-moz-focus-inner {
  border: 0 !important;
}

.sw > .nav .nav-link.disabled {
  color: #ccc !important;
  pointer-events: none;
  cursor: default;
}

.sw > .nav .nav-link.hidden {
  display: none !important;
}

.sw.sw-justified > .nav .nav-link,
.sw.sw-justified > .nav > li {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.sw.sw-dark {
  color: rgba(255, 255, 255, 0.95);
  background: #000;
}

.sw.sw-loading {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.sw.sw-loading::after {
  content: "";
  display: block;
  position: absolute;
  opacity: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2;
  transition: all 0.2s ease;
}

.sw.sw-loading::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 45%;
  left: 45%;
  width: 2rem;
  height: 2rem;
  border: 10px solid #f3f3f3;
  border-top: 10px solid #3498db;
  border-radius: 50%;
  z-index: 10;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.sw-theme-default {
  border: 1px solid #eee;
}

.sw-theme-default > .tab-content > .tab-pane {
  padding: 10px;
}

.sw-theme-default .toolbar > .btn {
  color: #fff;
  background-color: #556ee6;
  border: 1px solid #556ee6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-weight: 400;
}

.sw-theme-default > .nav {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1) !important;
}

.sw-theme-default > .nav .nav-link {
  position: relative;
  height: 100%;
  min-height: 100%;
}

.sw-theme-default > .nav .nav-link::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 0;
  left: 0;
  bottom: -1px;
  background: rgb(146, 144, 144);
  transition: all 0.35s ease 0.15s;
}

.sw-theme-default > .nav .nav-link.inactive {
  color: #999;
  cursor: not-allowed;
}

.sw-theme-default > .nav .nav-link.active {
  color: #556ee6 !important;
  cursor: pointer;
}

.sw-theme-default > .nav .nav-link.active::after {
  background: #556ee6 !important;
  width: 100%;
}

.sw-theme-default > .nav .nav-link.done {
  color: #d3d3d0 !important;
  cursor: pointer;
}

.sw-theme-default > .nav .nav-link.done::after {
  background: #d3d3d0;
  width: 100%;
}

.sw-theme-default > .nav .nav-link.disabled {
  color: #ddd !important;
  cursor: not-allowed;
}

.sw-theme-default > .nav .nav-link.disabled::after {
  background: #ddd;
  width: 100%;
}

.sw-theme-default > .nav .nav-link.danger {
  color: #d9534f !important;
  cursor: pointer;
}

.sw-theme-default > .nav .nav-link.danger::after {
  background: #d9534f;
  width: 100%;
}

.sw-theme-arrows {
  border: none;
  box-shadow: 0 7px 30px -10px rgba(150, 170, 180, 0.5);
}

.sw-theme-arrows > .tab-content > .tab-pane {
  padding: 10px;
}

.sw-theme-arrows .toolbar > .btn {
  color: #fff;
  background-color: #556ee6;
  border: 1px solid #556ee6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-weight: 400;
}

.sw-theme-arrows > .nav {
  overflow: hidden;
  border-bottom: 1px solid #eee;
}

.sw-theme-arrows > .nav .nav-link {
  position: relative;
  height: 100%;
  min-height: 100%;
  margin-right: 20px;
  margin-left: -20px;
  padding-left: 40px;
}

@media screen and (max-width: 640px) {
  .sw-theme-arrows > .nav .nav-link {
    overflow: hidden;
    margin-bottom: 1px;
    margin-right: unset;
  }
}

.sw-theme-arrows > .nav .nav-link::after {
  content: "";
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  top: 50%;
  left: 100%;
  margin-top: -50px;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-left: 30px solid #f8f8f8;
  z-index: 2;
}

.sw-theme-arrows > .nav .nav-link::before {
  content: " ";
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  top: 50%;
  left: 100%;
  margin-top: -50px;
  margin-left: 1px;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-left: 30px solid #eee;
  z-index: 1;
}

.sw-theme-arrows > .nav .nav-link.inactive {
  color: #999;
  border-color: #f8f8f8;
  background: #f8f8f8;
  cursor: not-allowed;
}

.sw-theme-arrows > .nav .nav-link.active {
  color: #fff;
  border-color: #92928e;
  background: #92928e;
  cursor: default;
}

.sw-theme-arrows > .nav .nav-link.active::after {
  border-left-color: #92928e;
}

.sw-theme-arrows > .nav .nav-link.done {
  color: rgb(124, 124, 124);
  border-color: #d3d3d0;
  background: #d3d3d0;
  cursor: default;
}

.sw-theme-arrows > .nav .nav-link.done::after {
  border-left-color: #d3d3d0;
}

.sw-theme-arrows > .nav .nav-link.disabled {
  color: #eee;
  border-color: #f9f9f9;
  background: #f9f9f9;
  cursor: not-allowed;
}

.sw-theme-arrows > .nav .nav-link.disabled::after {
  border-left-color: #f9f9f9;
}

.sw-theme-arrows > .nav .nav-link.danger {
  color: #fff;
  border-color: #d9534f;
  background: #d9534f;
  cursor: pointer;
}

.sw-theme-arrows > .nav .nav-link.danger::after {
  border-left-color: #d9534f;
}

.sw-theme-arrows.sw-dark {
  color: rgba(255, 255, 255, 0.95);
  background: #000;
}

.sw-theme-arrows.sw-dark > .nav {
  border-bottom: 1px solid #555;
}

.sw-theme-arrows.sw-dark > .nav .nav-link::after {
  border-left: 30px solid #5f5f5f;
}

.sw-theme-arrows.sw-dark > .nav .nav-link::before {
  border-left: 30px solid #555;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.inactive {
  color: #fff;
  border-color: #5f5f5f;
  background: #5f5f5f;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.inactive::after {
  border-left-color: #5f5f5f;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.active {
  color: #fff;
  border-color: #010506;
  background: #0a2730;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.active::after {
  border-left-color: #0a2730;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.done {
  color: #fff;
  border-color: #000;
  background: #000;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.done::after {
  border-left-color: #000;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.disabled {
  color: #555 !important;
  border-color: #f9f9f9;
  background: #474747;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.disabled::after {
  border-left-color: #474747;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.danger {
  color: #fff;
  border-color: #d9534f;
  background: #d9534f;
}

.sw-theme-arrows.sw-dark > .nav .nav-link.danger::after {
  border-left-color: #d9534f;
}

.sw-theme-dots > .tab-content > .tab-pane {
  padding: 10px;
}

.sw-theme-dots .toolbar > .btn {
  color: #fff;
  background-color: #556ee6;
  border: 1px solid #556ee6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-weight: 400;
}

.sw-theme-dots > .nav {
  position: relative;
  margin-bottom: 10px;
}

.sw-theme-dots > .nav::before {
  content: " ";
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  height: 5px;
  background-color: #eee;
  border-radius: 3px;
  z-index: 1;
}

.sw-theme-dots > .nav .nav-link {
  position: relative;
  margin-top: 40px;
}

.sw-theme-dots > .nav .nav-link::before {
  content: " ";
  position: absolute;
  display: block;
  top: -36px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #f5f5f5;
  color: #428bca;
  text-decoration: none;
  z-index: 98;
}

.sw-theme-dots > .nav .nav-link::after {
  content: " ";
  position: absolute;
  display: block;
  top: -28px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  z-index: 99;
}

.sw-theme-dots > .nav .nav-link.inactive {
  color: #999;
  cursor: not-allowed;
}

.sw-theme-dots > .nav .nav-link.inactive::after {
  background-color: #999;
}

.sw-theme-dots > .nav .nav-link.active {
  color: #92928e !important;
  cursor: pointer;
}

.sw-theme-dots > .nav .nav-link.active::after {
  background-color: #92928e !important;
}

.sw-theme-dots > .nav .nav-link-danger.active::after {
  background-color: red !important;
}

.sw-theme-dots > .nav .nav-link.done {
  color: #d3d3d0;
  cursor: pointer;
}

.sw-theme-dots > .nav .nav-link.done::after {
  background-color: #d3d3d0;
}

.sw-theme-dots > .nav .nav-link.disabled {
  color: #f9f9f9;
  cursor: not-allowed;
}

.sw-theme-dots > .nav .nav-link.disabled::after {
  background-color: #f9f9f9;
}

.sw-theme-dots > .nav .nav-link.danger {
  color: #d9534f;
  cursor: pointer;
}

.sw-theme-dots > .nav .nav-link.danger::after {
  background-color: #d9534f;
}

.sw-theme-dots.sw-dark {
  color: rgba(255, 255, 255, 0.95);
  background: #000;
}

.sw-theme-dots.sw-dark > .nav::before {
  background-color: #3c3c3c;
}

.sw-theme-dots.sw-dark > .nav .nav-link::before {
  background: #434343;
  color: #000;
}

.sw-theme-progress {
  border: 1px solid #eee;
}

.sw-theme-progress > .tab-content > .tab-pane {
  padding: 10px;
}

.sw-theme-progress .toolbar > .btn {
  color: #fff;
  background-color: #556ee6;
  border: 1px solid #556ee6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-weight: 400;
}

.sw-theme-progress > .nav {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1) !important;
}

.sw-theme-progress > .nav .nav-link {
  position: relative;
  height: 100%;
  min-height: 100%;
  background: 0 0;
  overflow: hidden;
  z-index: 2;
}

.sw-theme-progress > .nav .nav-link::after {
  content: "";
  position: absolute;
  height: 150%;
  width: 0;
  left: 0;
  top: 0;
  background: #fff;
  z-index: -1;
  transition: all 0.35s ease 0.1s;
}

.sw-theme-progress > .nav .nav-link.inactive {
  color: #999;
  cursor: not-allowed;
}

.sw-theme-progress > .nav .nav-link.active {
  color: #fff !important;
  cursor: pointer;
}

.sw-theme-progress > .nav .nav-link.active::after {
  background-color: #d3d3d0;
  width: 100%;
}

.sw-theme-progress > .nav .nav-link.done {
  color: #fff !important;
  cursor: pointer;
}

.sw-theme-progress > .nav .nav-link.done::after {
  background: #d3d3d0;
  width: 100%;
}

.sw-theme-progress > .nav .nav-link.disabled {
  color: #ddd !important;
  cursor: not-allowed;
}

.sw-theme-progress > .nav .nav-link.disabled::after {
  background: #f9f9f9;
  width: 100%;
}

.sw-theme-progress > .nav .nav-link.danger {
  color: #fff !important;
  cursor: pointer;
}

.sw-theme-progress > .nav .nav-link.danger::after {
  background: #d9534f;
  width: 100%;
}

.sw-theme-progress.sw-dark {
  color: rgba(255, 255, 255, 0.95);
}

.sw-theme-progress.sw-dark > .nav .nav-link.active {
  color: #fff;
}

.sw-theme-progress.sw-dark > .nav .nav-link.active::after {
  background-color: #333;
}

.sw-theme-progress.sw-dark > .nav .nav-link.done {
  color: #fff !important;
}

.sw-theme-progress.sw-dark > .nav .nav-link.done::after {
  background: #333;
}

.sw-theme-progress.sw-dark > .nav .nav-link.disabled {
  color: #2b2b2b !important;
}

.sw-theme-progress.sw-dark > .nav .nav-link.disabled::after {
  background: #474747;
}

.sw-theme-progress.sw-dark > .nav .nav-link.danger {
  color: #fff !important;
}

.sw-theme-progress.sw-dark > .nav .nav-link.danger::after {
  background: #d9534f;
}
</style>
